import FloatingLabelInput from './FloatingLabelInput';

export default FloatingLabelInput;



// WEBPACK FOOTER //
// ./src/components/common/FloatingLabelInput/index.js